import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { handleToggleTranscriptCreator } from 'creators/shareVideo';

import TranscriptHeader from './transcript-header';
import TranscriptWrapper from './transcript-wrapper';
import SharePageCard from '../share-page-card';

function Transcript({ onRightPanel = false, height }) {
  const dispatch = useDispatch();
  const [showFullHeader, setShowFullHeader] = useState(true);
  const onExit = useCallback(() => {
    dispatch(handleToggleTranscriptCreator());
  }, [dispatch]);

  return (
    <SharePageCard
      onRightPanel={onRightPanel}
      height={height}
      header={
        <TranscriptHeader showFullHeader={showFullHeader} onExit={onExit} />
      }
    >
      <TranscriptWrapper
        showFullHeader={showFullHeader}
        setShowFullHeader={setShowFullHeader}
      />
    </SharePageCard>
  );
}

export default Transcript;
